// extracted by mini-css-extract-plugin
export default {"heading":"HardwareFirstAppCarousel_heading__+UrPo","carousel":"HardwareFirstAppCarousel_carousel__ZukBX","image":"HardwareFirstAppCarousel_image__8+IwA"};